import React from "react";
import Chart from "react-apexcharts";
import "./Donut.scss";

const Donut = ({series = []}) => {

  const options = {
    chart: {
      type: "donut",
      height: 55,
      width: 104,
    },
    tooltip: {
      enabled: true,
    },
    sparkline: {
      enabled: true,
    },
    labels: ["Pending", "Recovered"],
    colors: ["#6ca0ff", "#ff6a4d"],
    legend: {
      position: "right",
      markers: {
        width: 12,
        height: 12,
        radius: 12,
      },
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 90,
        donut: {
          size: "70%",
        },
      },
    },
    dataLabels: {
      enabled: true, // Needed so Apex renders them — we control visibility via CSS
      style: {
        fontSize: "12px",
        fontWeight: "bold",
      },
      formatter: (val) => `${val.toFixed(0)}%`,
    },
  };

  return (
    <div className="donutWrapper">
      <Chart options={options} series={series} type="donut" height={130} />
    </div>
  );
};

export default Donut;
